import { useNavigate } from '@tanstack/react-router';

import { BaseModal, BaseModalContent } from 'src/shared/components/ui/modals/BaseModal';
import { useRouteSearch } from 'src/shared/hooks/useRouteSearch';

export const CALLBACK_ERRORS = {
  FAILED: 'Something went wrong trying to connect.',
  CONNECTION_ALREADY_EXISTS: 'This connection already exists in another org.',
};

export default function ConnectError() {
  const navigate = useNavigate();
  const { param: error, deleteParam: deleteError } = useRouteSearch('/_authenticated/integrations/', 'error');
  const { param: connectionType, deleteParam: deleteConnectionType } = useRouteSearch(
    '/_authenticated/integrations/',
    'connection_type'
  );
  const callbackError =
    (error in CALLBACK_ERRORS && CALLBACK_ERRORS[error as keyof typeof CALLBACK_ERRORS]) || CALLBACK_ERRORS['FAILED'];

  return (
    <BaseModal
      open={Boolean(error && connectionType === 'connect')}
      onOpenChange={(open) => {
        if (!open) {
          deleteConnectionType();
          deleteError();
        }
      }}
    >
      <BaseModalContent
        subtleTitle="Failed to connect"
        title="We had an issue connecting to your inbox"
        description={callbackError}
        confirmText="Try again"
        cancelText="Close"
        onConfirm={() => navigate({ to: '/integrations' as string })}
      />
    </BaseModal>
  );
}
